import decodeJwt from 'jwt-decode';
import { Roles } from './Enums';

enum ClaimType {
    Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
    Permissions = 'http://schemas.tour24.com/2024/126/identity/claims/permissions',
    Id = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
    Username = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
    FirstName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
    LastName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
    Email = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
}

interface Jwt {
    [ClaimType.Role]: string;
    [ClaimType.Permissions]: string[]
    [ClaimType.Id]: string;
    [ClaimType.Username]: string;
    [ClaimType.FirstName]: string | undefined;
    [ClaimType.LastName]: string | undefined;
    [ClaimType.Email]: string | undefined;
}

export const getJwt = () => {
    return localStorage.getItem('t24:jwt') || '';
};

export const isAuthenticated = () => {
    return getJwt() !== '';
};

const getMyClaimValue = (claim: ClaimType) => {
    let jwt = getJwt();
    if (jwt === '' || jwt === undefined || jwt === null) {
        return undefined;
    }
    let decodedToken = decodeJwt<Jwt>(jwt);
    return decodedToken[claim];
};

export const getMyId = () => getMyClaimValue(ClaimType.Id);
export const getMyRole = () => getMyClaimValue(ClaimType.Role);
export const getMyPermissions = () => getMyClaimValue(ClaimType.Permissions);
export const getMyUsername = () => getMyClaimValue(ClaimType.Username);
export const getMyFirstName = () => getMyClaimValue(ClaimType.FirstName);
export const getMyLastName = () => getMyClaimValue(ClaimType.LastName);
export const getMyFullName = () =>
    `${getMyClaimValue(ClaimType.FirstName)} ${getMyClaimValue(ClaimType.LastName)}`;
export const getMyEmail = () => getMyClaimValue(ClaimType.Email);

export const userIsSystemAdmin = (): boolean => getMyRole() === Roles.SystemAdmin;

export const userIsCompanyAdmin = (): boolean => getMyRole() === Roles.CompanyAdmin;

export const userIsPropertyAdmin = (): boolean => getMyRole() === Roles.PropertyAdmin;

export const prospectLoggedIn = (): boolean => getMyRole() === Roles.ProspectUser;

export const userIsCompanyAnalyticsUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.CompanyAnalyticsUser);
};

export const userIsCompanyManageAdmin = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.CompanyManageAdmin);
};

export const userIsCompanyManageUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.CompanyManageUser);
};

export const userIsCompanyDashboardAdmin = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.CompanyDashboardAdmin);
};

export const userIsCompanyDashboardUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.CompanyDashboardUser);
};

export const userIsPropertyAnalyticsUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.PropertyAnalyticsUser);
};

export const userIsPropertyManageAdmin = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.PropertyManageAdmin);
};

export const userIsPropertyManageUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.PropertyManageUser);
};

export const userIsPropertyDashboardAdmin = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.PropertyDashboardAdmin);
};

export const userIsPropertyDashboardUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.PropertyDashboardUser);
};

export const userIsSystemAnalyticsUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.SystemAnalyticsUser);
};

export const userIsSystemManageAdmin = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.SystemManageAdmin);
};

export const userIsSystemManageUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.SystemManageUser);
};

export const userIsSystemDashboardAdmin = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.SystemDashboardAdmin);
};

export const userIsSystemDashboardUser = (): boolean => {
    const permissions = getMyPermissions();
    return Array.isArray(permissions) && permissions.includes(Roles.SystemDashboardUser);
};



export const userHasPropertyAccess = (): boolean => {
    var role = getMyRole();
    return (
        role === Roles.CustomerSupportRepresentative ||
        role === Roles.SystemAdmin ||
        role === Roles.CompanyAdmin ||
        role === Roles.PropertyAdmin ||
        role === Roles.PropertyUser ||
        role === Roles.CompanyAnalyticsUser ||
        role === Roles.CompanyManageAdmin ||
        role === Roles.CompanyManageUser ||
        role === Roles.CompanyDashboardAdmin ||
        role === Roles.CompanyDashboardUser ||
        role === Roles.PropertyAnalyticsUser ||
        role === Roles.PropertyManageAdmin ||
        role === Roles.PropertyManageUser ||
        role === Roles.PropertyDashboardAdmin ||
        role === Roles.PropertyDashboardUser ||
        role === Roles.SystemAnalyticsUser ||
        role === Roles.SystemManageAdmin ||
        role === Roles.SystemManageUser ||
        role === Roles.SystemDashboardAdmin ||
        role === Roles.SystemDashboardUser 
    );
};

export const getRefreshToken = (): string => {
    return localStorage.getItem('t24:refreshToken') || '';
};

export const setTokens = (jwt: string, refreshToken: string) => {
    localStorage.setItem('t24:jwt', jwt);
    localStorage.setItem('t24:refreshToken', refreshToken);
};

export const clearToken = () => {
    localStorage.removeItem('t24:jwt');
    localStorage.removeItem('t24:refreshToken');
};



// WEBPACK FOOTER //
// ./src/utilities/identity.ts